import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-298c30fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row vertical-top q-pa-none justify-between" }
const _hoisted_2 = { class: "q-ma-none" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "q-pt-md q-pb-xl" }



interface Prop {
  title: string,
  subTitle?: string
  abst?: string[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCard',
  props: {
    title: null,
    subTitle: null,
    abst: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.title), 1),
        _withDirectives(_createElementVNode("span", null, "_", 512), [
          [_vShow, __props.subTitle !== void 0]
        ]),
        (_ctx.$q.platform.is.mobile)
          ? (_openBlock(), _createElementBlock("br", _hoisted_3))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(__props.subTitle), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.abst, (text) => {
        return (_openBlock(), _createElementBlock("p", { key: text }, _toDisplayString(text), 1))
      }), 128)),
      _renderSlot(_ctx.$slots, "abst")
    ])
  ], 64))
}
}

})